import React from 'react';
import { useTranslation } from 'react-i18next';
import UserSelectionBase from './UserSelectionBase';

/**
 * EmployeeSelection Component
 *
 * Multi-select autocomplete for choosing employees in the organizational tree.
 * Always allows multiple selections regardless of node level.
 *
 * @param {Object[]} selectedEmployees - Array of selected employee objects
 * @param {Object[]} filteredEmployees - Array of employee search results
 * @param {Function} searchEmployees - Search handler for filtering employees
 * @param {boolean} disabled - Whether to disable the field
 * @param {boolean} disableInviteUsers - Whether to disable adding users emails invitations for external users without privileges
 * @param {Function} onEmployeesChange - Handler for employee selection changes
 */
export default function EmployeeSelection({
  selectedEmployees,
  filteredEmployees,
  searchEmployees,
  onEmployeesChange,
  disableInviteUsers = false,
  disabled = false,
}) {
  const { t } = useTranslation();
  return (
    <UserSelectionBase
      label={t('employees')}
      multiple
      value={selectedEmployees}
      suggestions={filteredEmployees}
      completeMethod={searchEmployees}
      onChange={onEmployeesChange}
      placeholder={
        disableInviteUsers
          ? t('search_users')
          : t('search_users_or_type_emails')
      }
      enableKeyboardAdd={!disableInviteUsers}
      disabled={disabled}
    />
  );
}
